import { Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)`
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
  margin-bottom: 16px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 36px;
    line-height: 43px;
    margin-bottom: 24px;
  }
`;

export const CourseSectionTabs = styled(Tabs)`
  &.multiline {
    ${({ theme }) => theme.breakpoints.down('lg')} {
      .MuiTabs-flexContainer {
        align-items: stretch;
      }

      .MuiTabs-indicator {
        height: ${({ theme }) => theme.spacing(0.5)};
      }

      .MuiTab-root {
        flex: 0 0 auto;
        max-width: ${({ theme }) => theme.typography.pxToRem(250)};
        min-width: auto;
        min-height: auto;
        padding: ${({ theme }) => theme.spacing(1.5, 2)};
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        text-align: center;
        font-size: ${({ theme }) => theme.typography.h6.fontSize};
        font-weight: ${({ theme }) => theme.typography.h6.fontWeight};
        line-height: ${({ theme }) => theme.typography.h6.lineHeight};
        color: ${({ theme }) => theme.palette.text.secondary};

        &.Mui-selected {
          color: ${({ theme }) => theme.palette.primary.main};
        }
      }
    }
  }
`;

export const StyleTab = styled(Tab)`
  flex: 1;
  text-transform: none;
`;
